<template>
  <div
    :class="cardClass"
  >
    <div
      class="l-grid l-grid--2-col l-grid--mobile-tab-port"
    >
      <div class="c-image-layered-card__image-container">
        <img
          :src="image.src"
          :alt="image.title || image.alt || 'Feature image'"
          class="c-image-layered-card__image u-hidden-phone"
        >
        <img
          :src="mobileImage.src"
          :alt="mobileImage.title || mobileImage.alt || 'Feature image'"
          class="c-image-layered-card__mobile-image u-visible-phone"
        >
      </div>
      <div
        class="c-image-layered-card__content"
        :class="gridItemClass"
      >
        <h2
          v-if="title"
          :class="titleClass"
          :style="{ fontFamily: titleFont }"
        >
          {{ title }}
        </h2>
        <div
          v-if="featured"
          class="c-image-layered-card__featured-bar u-margin-bottom-small"
        />
        <h3
          v-if="subtitle"
          :class="subtitleClass"
          :style="{ fontFamily: subtitleFont }"
        >
          {{ subtitle }}
        </h3>
        <wysiwyg
          v-if="description"
          :class="wysiwygClass"
          paragraph-size="large"
          :html="description"
        />
        <btn
          v-if="cta"
          v-bind="cta"
        >
          {{ cta.text }}
        </btn>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '../button/Btn';
import Wysiwyg from "../wysiwyg/Wysiwyg";

export default {
  name: 'ContentCard',
  components: {
    Btn,
    Wysiwyg,
  },
  props: {
    textAlignment: {
      type: String,
      default: null,
    },
    image: {
      type: Object,
      default: ()=> ({}),
    },
    mobileImage: {
      type: Object,
      default: ()=> ({}),
    },
    imageSide: {
      type: String,
      default: 'left',
    },
    video: {
      type: Object,
      default: null,
    },
    imageHeight: {
      type: String,
      default: '',
    },
    imageWidth: {
      type: String,
      default: '',
    },
    cta: {
      type: Object,
      default: null
    },
    whiteText: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleFont: {
      type: String,
      default: 'Poppins'
    },
    description: {
      type: String,
      default: ()=> '',
    },
    title: {
      type: String,
      default: '',
    },
    titleFont: {
      type: String,
      default: 'Poppins'
    },
    buttonType: {
      type: String,
      default: 'link',
    },
    featured: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    cardClass() {
      let results = 'c-image-layered-card'
      if (this.textAlignment) {
        results += " u-text-align-" + this.textAlignment;
      }
      if (this.imageSide == 'right') {
        results += ' c-image-layered-card--image-right'
      }
      return results;
    },
    titleClass() {
      let results = 't-heading-1 u-margin-bottom-small';
      if (this.featured) {
        results += ' c-image-layered-card__title'
      }
      if (this.whiteText) {
        results += ' t-heading-1--white'
      }
      return results;
    },
    subtitleClass() {
      let results = 't-heading-5 u-margin-bottom-xx-small';
      if (this.featured) {
        results += ' c-image-layered-card__subtitle'
      }
      if (this.whiteText) {
        results += ' t-heading-7--white'
      }
      return results;
    },
    wysiwygClass() {
      let wysiwygClass = '';
      if (this.cta) {
        wysiwygClass += " u-margin-bottom-medium";
      }
      if (this.featured) {
        wysiwygClass += " c-image-layered-card__description";
      }
      if (this.whiteText) {
        wysiwygClass += " u-foreground-white";
      }
      return wysiwygClass;
    },
    gridItemClass() {
      if(this.imageSide == 'right') {
        return 'l-grid__item l-grid__item--first-until-tab-port'
      } else {
        return 'l-grid__item'
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .c-image-layered-card {
    @include themify($themes) {
      background: linear-gradient(to left, themed('background', 'xx-light') 95%, transparent 5%);
    }
    &--image-right {
      @include themify($themes) {
        background: linear-gradient(to right, themed('background', 'xx-light') 95%, transparent 5%);
      }
      @include respond(tab-port) {
        @include themify($themes) {
          background: none;
        }
      }
    }
    @include respond(tab-port) {
      @include themify($themes) {
        background: none;
      }
    }
    @include respond(tab-port) {
      text-align: center;
    }
     .l-grid {
       min-height: rem(600px);
       @include respond(tab-port) {
         min-height: auto;
       }
     }
    &__content {
      padding: rem(30px);
    }
    &__image {
      width: 100%;
    }
    &__mobile-image {
      display: none;
      max-width: 100%;
    }

    &__title {
      font-size: rem(80px);
      line-height: rem(50px);
      letter-spacing: rem(.08px);
      font-weight: $font-weight-book;
      text-transform: lowercase;
    }

    &__subtitle {
      max-width: rem(350px);
    }
    &__featured-bar {
      width: 61px;
      height: 10px;
      @include themify($themes) {
        background-color: themed('secondary')
      }
      @include respond(tab-port) {
        margin: auto;
      }
    }
  }
</style>
